import React, { useEffect, useState } from "react";
import IdeaBrain from "../Images/Brains/idea.png";

// Typing + Deleting effect
const TypingList = ({ items, speed = 50, pause = 2000, className = "" }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [text, setText] = useState("");
  const [isTyping, setIsTyping] = useState(true);

  useEffect(() => {
    const current = items[currentIndex];
    let timeout;

    if (isTyping) {
      if (text.length < current.length) {
        timeout = setTimeout(() => {
          setText(current.slice(0, text.length + 1));
        }, speed);
      } else {
        timeout = setTimeout(() => setIsTyping(false), pause);
      }
    } else {
      if (text.length > 0) {
        timeout = setTimeout(() => {
          setText((prev) => prev.slice(0, -1));
        }, speed / 2);
      } else {
        setIsTyping(true);
        setCurrentIndex((prev) => (prev + 1) % items.length);
      }
    }

    return () => clearTimeout(timeout);
  }, [text, isTyping, currentIndex, items, speed, pause]);

  return (
    <p className={`text-center ${className}`}>
      {text}
      <span className="animate-pulse">|</span>
    </p>
  );
};

function Sponsor() {
  const bullets = [
    "reach top machine learning talent ✨",
    "target specific skillsets with custom challenges 🎯",
    "build awareness and engagement with your brand 🎉",
    "no extra engineering resources needed — we handle it all 😌",
    "support learning, community outreach, and innovation 💡",
  ];

  return (
    <div className="min-h-screen flex flex-col items-center pt-16">
      <div className="flex flex-row items-center gap-4 mb-6 p-4">
        <h1 className="text-4xl font-bold text-center">sponsor a contest!</h1>
        <img src={IdeaBrain} alt="Idea Brain" className="h-16 w-auto" />
      </div>

      <TypingList
        items={bullets}
        className="text-2xl text-gray-800 min-h-[2.5rem]"
      />

      <div className="mt-8 w-full max-w-3xl flex flex-col items-ceter px-4">
        <p className="text-lg mb-4 text-center px-2">
          book a call with our founders to explore sponsorship options 🤝🏻
        </p>
        <iframe
          src="https://calendly.com/brainrot4ai/30min"
          className="w-full h-[500px] border-2 rounded-xl shadow-lg"
          title="Book a Sponsorship Call"
        ></iframe>
      </div>
    </div>
  );
}

export default Sponsor;
